import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ScoreCopyText(
    $projectId: ID!
    $assetType: String!
    $text: String!
    $html: String
    $scoringMethod: ScoringMethodInput
  ) {
    scoreCopyText(
      projectId: $projectId
      assetType: $assetType
      text: $text
      html: $html
      scoringMethod: $scoringMethod
    ) {
      score
      ageScoreHistogram
      genderScoreHistogram
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        name
        type
      }
      secondaryScoringMethod {
        id
        name
        type
      }
    }
  }
`;

export const scoreCopyText = ({ projectId, assetType, text, html, scoringMethod }, options) => {
  const variables = { projectId, assetType, text, html, scoringMethod };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
